<i [class]="iconClass()"></i>
